import React from 'react';
import { Typography } from '@material-ui/core';

export const MyOkrs: React.FC<any> = (props) => {
	const { t } = props;
	return <Typography>{t('myOkrsLabel')}</Typography>;
};
